import React, { useMemo } from "react";

const SummaryView = ({ list, loading, error, selectedOrg }) => {

    const displayList = useMemo(() => {

        if (selectedOrg === "All") {
            return list;
        }

        return list.filter(
            item => String(item.orgId) === selectedOrg
        );

    }, [list, selectedOrg]);

    const groupedList = useMemo(() => {

        const map = {};

        displayList.forEach(item => {

            if (!map[item.orgId]) {
                map[item.orgId] = [];
            }

            map[item.orgId].push(item);

        });

        return map;

    }, [displayList]);
    
    if (loading) {
        return (
            <div className="table-container">
                <div className="loading">
                    Loading...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="table-container">
                <div className="error-banner">
                    {error?.message || String(error)}
                </div>
            </div>
        );
    }

    if (displayList.length === 0) {
        return (
            <div className="table-container">
                <div className="empty">
                    No Data
                </div>
            </div>
        );
    }

    return (

        <div className="table-container">

            <div className="table-wrapper modern-table">

                <table>

                    <tbody>

                    {

                        Object.entries(groupedList).map(

                            ([orgId, items]) => {

                                const patientCount =

                                    new Set(

                                        items
                                            .map(i => i.patientId)
                                            .filter(Boolean)

                                    ).size;

                                return (

                                    <React.Fragment key={orgId}>

                                        {/* Org Header */}

                                        <tr className="org-row">

                                            <td colSpan={7}>

                                                <span className="org-id-highlight">

                                                    Org ID: {orgId}

                                                </span>

                                                <span className="org-divider">

                                                    ｜

                                                </span>

                                                <span className="org-count-highlight">

                                                    Cases: {items.length}

                                                </span>

                                                <span className="org-divider">

                                                    ｜

                                                </span>

                                                <span className="org-patient-highlight">

                                                    Patients: {patientCount}

                                                </span>

                                            </td>

                                        </tr>

                                        {/* Table Header */}

                                        <tr className="group-header">

                                            <th>Case ID</th>

                                            <th>Case No</th>

                                            <th>Patient ID</th>

                                            <th>Patient No</th>

                                            <th>User ID</th>

                                            <th>User Email</th>

                                            <th>Create Time</th>

                                        </tr>

                                        {

                                            items.map(item => (

                                                <tr
                                                    key={item.caseId}
                                                >

                                                    <td>

                                                        {item.caseId}

                                                    </td>

                                                    <td>

                                                        {item.caseNo || "-"}

                                                    </td>

                                                    <td>

                                                        {item.patientId}

                                                    </td>

                                                    <td>

                                                        {item.patientNo || "-"}

                                                    </td>

                                                    <td>

                                                        {item.userId || "-"}

                                                    </td>

                                                    <td>

                                                        {item.user || "-"}

                                                    </td>

                                                    <td>

                                                        {formatDate(
                                                            item.createTime
                                                        )}

                                                    </td>

                                                </tr>

                                            ))

                                        }

                                    </React.Fragment>

                                );

                            }

                        )

                    }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

function formatDate(v) {

    if (!v) {

        return "-";

    }

    return new Intl.DateTimeFormat(
        "en-US",
        {
            year:"numeric",
            month:"2-digit",
            day:"2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false             
        }
    ).format(new Date(v));

}

export default SummaryView;